import { useOrganizationMemberRoleQuery } from '@app/graphql';

const useIsOrganizationAdmin = ({
  organizationId,
  userEmail,
}: {
  organizationId?: string;
  userEmail?: string;
}) => {
  const [{ data }] = useOrganizationMemberRoleQuery({
    variables: {
      emailQuery: `email:'${userEmail}'`,
      organizationId: organizationId || '',
    },
    pause: !(organizationId && userEmail),
  });

  return organizationId &&
    userEmail &&
    data?.organization?.members?.edges.length &&
    data.organization.members.edges[0].role === 'ADMIN'
    ? true
    : false;
};

export { useIsOrganizationAdmin };
